export class AssetCategoryInfoInfo {
  AssetCategoryID: number
  AssetGroupCode: string
  AssetGroupName: string
  AssetCategoryCode: string
  AssetCategoryName: string
  AssetCategoryDesc: string
  AssetCategoryCreateDate: string
  AssetCategoryCreateBy: string
  AssetCategoryCreateByName: string
  AssetCategoryUpdateDate: string
  AssetCategoryUpdateBy: string
  AssetCategoryUpdateName: string
  AssetCategoryFlagDelete: string
  rowFetch: number
  rowOFFSet: number
  itemTotal: number
}
